import { ICON_BG_LIST } from '~/constants';

export const getIconColor = (key: number): string => {
  return ICON_BG_LIST[key % ICON_BG_LIST.length];
};

export const numberToColor = (value: number | string): string => {
  const strValue = String(value);
  const validChannelIdKeyForBg = parseInt(strValue.substr(0, 16), 10);
  return getIconColor(validChannelIdKeyForBg);
};
